<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-2">
        <DashboardCard
          :title="`Faturamento ${getUom() ? getUom() : ''} (R$)`"
          :total-value="getProductionBilledMonth()[0]?.VAL_TOTALPROBILLED_MONTH"
          :loading="getLoadingProduction"
          :size="'small'"
        />
      </div>
      <div class="col-md-2">
        <DashboardCard
          title="Devoluções (R$)"
          :total-value="getGoalMonth()[0]?.VAL_RETURN"
          :loading="getLoadingGoal"
          :size="'small'"
        />
      </div>
      <div class="col-md-1">
        <DashboardCard
          title="% Devoluções"
          :total-value="percentReturn()"
          :loading="getLoadingProduction"
          :size="'small'"
        />
      </div>
      <div class="col-md-2">
        <DashboardCard
          title="Meta Inicial"
          :total-value="getGoalMonth()[0]?.TOTALGOAL"
          :loading="getLoadingGoal"
          :size="'small'"
        />
      </div>
      <div class="col-md-2">
        <DashboardCard
          :title="`Total ${getUom() ? getUom() : ''} Faturados`"
          :total-value="getProductionBilledMonth()[0]?.TOTALPROBILLED_MONTH"
          :loading="getLoadingProduction"
          :size="'small'"
        />
      </div>
      <div class="col-md-1">
        <DashboardCard
          title="Saldo a Faturar"
          :total-value="stockToBilling()"
          :loading="getLoadingGoal || getLoadingProduction"
          :size="'small'"
        />
      </div>
      <div class="col-md-1">
        <DashboardCard
          title="Meta diária"
          :total-value="dailyGoal(stockToBilling()).toFixed(0)"
          :loading="getLoadingGoal || getLoadingProduction"
          :size="'small'"
        />
      </div>
      <div class="col-md-1">
        <DashboardCard
          title="Faturado Ontem"
          :total-value="getProductionBilledMonth()[0]?.TOTALPROBILLED_YESTERDAY"
          :loading="getLoadingProduction"
          :size="'small'"
        />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-2">
        <DashboardCard
          :title="`Faturamento ${getUom() ? getUom() : ''} Exportação (R$)`"
          :total-value="getProductionBilledMonth()[0]?.VAL_EXPORT_MONTH"
          :loading="getLoadingProduction"
          :size="'small'"
        />
      </div>
      <div class="col-md-2">
        <DashboardCard
          :title="`Total ${getUom() ? getUom() : ''} devolvido`"
          :total-value="getGoalMonth()[0]?.QTDE_RETURN"
          :loading="getLoadingGoal"
          :size="'small'"
        />
      </div>
      <div class="col-md-1">
        <DashboardCard
          :title="`Estoque atual ${getUom() ? getUom() : ''}`"
          :total-value="currentTotalStock()"
          :loading="getLoadingHistory"
          :size="'small'"
        />
      </div>
      <div class="col-md-2">
        <DashboardCard
          title="Entrada de Produção"
          :total-value="inputProduction()"
          :loading="getLoadingProduction"
          :size="'small'"
        />
      </div>
      <div class="col-md-2">
        <DashboardCard
          title="Iniciamos dia PED/DIA"
          :total-value="getProductionBilledMonth()[0]?.QTD_RES"
          :loading="getLoadingProduction"
          :size="'small'"
        />
      </div>
      <div class="col-md-1">
        <DashboardCard
          title="Coletado"
          :total-value="getProductionBilledMonth()[0]?.COLLECT"
          :loading="getLoadingProduction"
          :size="'small'"
        />
      </div>
      <div class="col-md-1">
        <DashboardCard
          title="Total Disp"
          :total-value="getProductionBilledMonth()[0]?.TOTAL_DISP"
          :loading="getLoadingProduction"
          :size="'small'"
        />
      </div>
      <div class="col-md-1">
        <DashboardCard
          title="Faturado Hoje"
          :total-value="getProductionBilledMonth()[0]?.TOTALPROBILLED_TODAY"
          :loading="getLoadingProduction"
          :size="'small'"
        />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-8 dash">
        <DashboardStorageHistory
          :totalStock="totalStockStorage()"
          :day="dayStorage()"
          :loading="getLoadingHistory"
        />
      </div>
      <div class="col-md-4 dash">
        <DashboardGoalBilled
          :totalGoal="totalGoal()"
          :totalBilled="totalBilled()"
          :month="month()"
          :loading="getLoadingGoal"
        />
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-12 dash">
        <DashboardProductionBilled
          :totalProduction="totalProduction()"
          :totalProBilled="invoiceQtde()"
          :day="dayProduction()"
          :loading="getLoadingProduction"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import DashboardStorageHistory from './DashboardStorageHistory.vue';
import DashboardProductionBilled from './DashboardProductionBilled.vue';
import DashboardGoalBilled from './DashboardGoalBilled.vue';
import DashboardCard from '@/modules/dashboard/components/DashboardCard.vue';
import { mapActions, mapGetters } from 'vuex';
import { BarChart, LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';

use([
  BarChart,
  LineChart,
  CanvasRenderer,
  GridComponent,
  TooltipComponent,
  LegendComponent,
]);

export default defineComponent({
  components: {
    DashboardProductionBilled,
    DashboardStorageHistory,
    DashboardGoalBilled,
    DashboardCard,
  },

  methods: {
    ...mapActions('dashboardBillingIndicator', [
      'fetchProductionBilled',
      'fetchStorageHistory',
      'fetchGoalBilling',
    ]),
    totalProduction() {
      return this.productionBilled.map((day, index) => [
        index,
        day.TOTALPRODUCTION,
      ]);
    },

    invoiceQtde() {
      return this.productionBilled.map((day, index) => [
        index,
        day.TOTALPROBILLED,
      ]);
    },

    dayProduction() {
      return this.productionBilled.map((day) => {
        return new Date(day.DAY).toLocaleDateString('pt-BR', {
          month: '2-digit',
          day: '2-digit',
        });
      });
    },
    totalStockStorage() {
      return this.storageHistory.map((day, index) => [index, day.TOTALSTOCK]);
    },

    dayStorage() {
      return this.storageHistory.map((day) => {
        return new Date(day.DAY).toLocaleDateString('pt-BR', {
          month: '2-digit',
          day: '2-digit',
        });
      });
    },
    totalGoal() {
      return this.goalBilling.map((day) => day.TOTALGOAL);
    },

    totalBilled() {
      return this.goalBilling.map((day) => day.TOTALBILLED);
    },

    month() {
      return this.goalBilling.map((day) => day.MONTH);
    },

    percentReturn() {
      return Number(
        (this.getGoalMonth()[0]?.VAL_RETURN /
          this.getGoalMonth()[0]?.TOTALVALBILLED) *
          100
      ).toFixed(2);
    },

    stockToBilling() {
      return Math.max(
        (this.getGoalMonth()[0]?.TOTALGOAL || 0) -
          (this.getProductionBilledMonth()[0]?.TOTALPROBILLED_MONTH || 0),
        0
      );
    },

    dailyGoal(value) {
      const today = new Date();
      const lastDayMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      ).getDate();
      const remainingDay = lastDayMonth - today.getDate();
      return remainingDay > 0 ? value / remainingDay : value;
    },

    currentTotalStock() {
      return this.storageHistory.length
        ? this.storageHistory[this.storageHistory.length - 1].TOTALSTOCK
        : null;
    },

    inputProduction() {
      return this.productionBilled.length
        ? this.productionBilled[this.productionBilled.length - 1]
            .TOTALPRODUCTION
        : null;
    },

    getProductionBilledMonth() {
      const [filteredYear, filteredMonth] = this.getSearchDate
        .trim()
        .split('-');
      const filteredDataMonth = this.productionBilled.find(
        (dado) =>
          dado.MONTH_NUMBER === Number(filteredMonth) &&
          dado.YEAR_NUMBER === Number(filteredYear)
      );
      return [filteredDataMonth] || [];
    },

    getGoalMonth() {
      const [filteredYear, filteredMonth] = this.getSearchDate
        .trim()
        .split('-');
      const filteredDataMonth = this.goalBilling.find(
        (dado) =>
          dado.MONTH_NUMBER === Number(filteredMonth) &&
          dado.YEAR_NUMBER === Number(filteredYear)
      );
      return [filteredDataMonth] || [];
    },

    getUom() {
      const segments = this.getSearchParams.segments
        ? this.getSearchParams.segments
        : [];
      if (segments.length === 1) {
        if (segments[0] === 1) return 'Pares';
        if (segments[0] === 2 || segments[0] === 5) return 'Peças';
      } else if (
        segments.length === 2 &&
        segments.includes(2) &&
        segments.includes(5)
      ) {
        return 'Peças';
      }
      return '';
    },
  },

  computed: {
    ...mapGetters('dashboardBillingIndicator', {
      productionBilled: 'getProductionBilled',
      storageHistory: 'getStorageHistory',
      goalBilling: 'getGoalBilling',
      getLoadingHistory: 'getLoadingHistory',
      getLoadingProduction: 'getLoadingProduction',
      getLoadingGoal: 'getLoadingGoal',
      getSearchDate: 'getSearchDate',
      getSearchParams: 'getSearchParams',
    }),
    ...mapGetters('auth', { getFilteredDateYYYYMM: 'getFilteredDateYYYYMM' }),
  },
});
</script>
<style lang="scss" scoped>
.dash {
  position: relative;
}
</style>
